import {
    Box,
    Divider,
    FormControlLabel,
    Checkbox,
    Typography,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    TextField,
    List,
    ListItem,
    ListItemText,
    Button,
    Slide,
    Dialog,
    ListItemAvatar,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useState, forwardRef, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import styled from 'styled-components';
import { DatePicker, LocalizationProvider, DesktopDatePicker, MobileTimePicker } from '@mui/lab';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { ReactComponent as ReturnIcon } from '../assets/return.svg';
import { DateRangePicker } from '@mui/lab';
import get_token from "../lib/get_token";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import moment from "moment";
import Swal from "sweetalert2";
import pr from "../lib/pr";
import get_cid from '../lib/get_cid';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const selectTheme = createTheme({
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    top: '-7px'
                },
                shrink: {
                    top: 0
                }
            },
        },
    }
})

const pickerTheme = createTheme({
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    height: '40px',
                    marginTop: '12px',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    top: '5px'
                },
                shrink: {
                    top: '12px'
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        }
    }
})

const calTheme = createTheme({
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    height: '40px',
                    // boxShadow: '5px 5px 5px #e7e7e7'
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    top: '-7px',
                },
                shrink: {
                    top: '0'
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    margin: '10px 0'
                }
            }
        }
    }
})

const tableTheme = createTheme({
    components: {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '0'
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    marginBottom: '16px'
                }
            }
        }
    }
})

const Input = styled('input')({
    display: 'none',
});

function Return(props) {
    const { login } = props;
    const [open, setOpen] = useState(false);
    const [agree, setAgree] = useState(false);
    const [coupon, setCoupon] = useState('');
    const [time, setTime] = useState(null);
    const [reason, setReason] = useState('');
    const token = get_token();
    const [reason_etc, setReason_etc] = useState('');
    const [file, setFile] = useState(null);
    const [rows, setRows] = useState([]);
    const [plans, setPlans] = useState([]);
    const [selected, setSelected] = useState([]);
    const [isChecked, setIsChecked] = useState([false]);
    const [seq, setSeq] = useState([]);
    const cid = get_cid();

    const columns = [
        { field: 'id', headerName: 'id', hide: true },
        { field: 'class_date', headerName: '수업일' },
        { field: 'class_hour', headerName: '수업시간' },
        { field: 'coupon', headerName: '쿠폰명' },
    ]

    const handleChange = (e) => {
        setCoupon(e.target.value);
    }
    const onChangeReason = (e) => {
        setReason(e.target.value);
    }

    const onConfirmClick = () => {
        setAgree(true);
    }

    const openClick = () => {
        setOpen(true);
        setSeq([]);
        setFile(null);
        setReason('');
        setReason_etc('');
    };
    const closeClick = () => {
        setOpen(false);

    };

    // const onChangeSdate = (newDate) => {
    //     setSdate(moment(newDate).format('YYYY-MM-DD'))
    // }
    // const onChangeEdate = (newDate) => {
    //     setEdate(moment(newDate).format('YYYY-MM-DD'))
    // }

    const onChangeEtc = (e) => {
        setReason_etc(e.target.value);
    }

    const changeImg = (e) => {
        setFile(e.target.files[0])
    }

    // 쿠폰 가져오기
    const load_data = async () => {
        pr('load_data')
        let result = await axios.post(configState.api + "/gympass/return_list", {
            token: token,
            mcd: login.mcd,
            level: login.level,
            cid: cid
        });
        setRows(result.data.rows);
        setPlans(result.data.plans);
    };

    useEffect(() => {
        if (open === true) {
            load_data();
        }
    }, [open])

    // const addFile = () => {
    //     const url = ''
    // }
    // const onSubmit = async () => {
    //     Swal.fire({
    //         title: '반환신청하시겠습니까?',
    //         html: `<div>${plans.coupon}</div>`,
    //         showConfirmButton: ture,
    //         showCancelButton: true,
    //     })
    //     .then(async (result) => {
    //         if(result.isConfirmed) {

    //         }
    //     })
    //     const formData = new FormData();
    //     if(file === null) {
    //         Swal.fire('Error', '증명서를 첨부하세요.');
    //         return;
    //     }
    //     formData.append('file', file);
    //     formData.append('token', token);
    //     formData.append('cid', configState.cid);
    //     formData.append('level', login.level);
    //     formData.append('mcd', login.mcd);
    //     formData.append('reason', reason);
    //     formData.append('reason_etc', reason_etc);
    //     formData.append('pt_reservation_seq', seq);
    //     console.log(formData);
    //     let result = await axios.post(configState.api + "/gympass/return_add", formData);

    //     if (result.data.success === 0) {
    //         Swal.fire('Error', result.data.msg);
    //         return;
    //     } else {
    //         Swal.fire('반환 신청 완료', '담당자 확인 후 14일 이내로 처리됩니다.')
    //             .then((result) => {
    //                 if (result.isConfirmed) {
    //                     closeClick();
    //                 }
    //             });
    //         return;
    //     }
    // }

    const onSubmit = async () => {
        if (seq.length === 0) {
            Swal.fire('Error', '쿠폰을 선택하세요')
        } else {
            Swal.fire({
                title: '반환신청하시겠습니까?',
                html: `<div>선택한 쿠폰은 ${seq.length}장입니다.</div>`,
                showConfirmButton: true,
                showCancelButton: true,
            })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        const formData = new FormData();
                        if (file === null) {
                            Swal.fire('Error', '증명서를 첨부하세요.');
                            return;
                        }
                        formData.append('file', file);
                        formData.append('token', token);
                        formData.append('cid', cid);
                        formData.append('level', login.level);
                        formData.append('mcd', login.mcd);
                        formData.append('reason', reason);
                        formData.append('reason_etc', reason_etc);
                        formData.append('pt_reservation_seq', seq);
                        let result = await axios.post(configState.api + "/gympass/return_add", formData);
                        if (result.data.success === 0) {
                            Swal.fire('Error', result.data.msg);
                            return;
                        } else {
                            Swal.fire('반환 신청 완료', '담당자 확인 후 14일 이내로 처리됩니다.')
                                .then(() => {
                                    closeClick();
                                });
                            return;
                        }
                    }


                })
        }


    }

    return (
        <Box>
            <Dialog fullScreen open={open} onClose={closeClick} TransitionComponent={Transition}>
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <img src='/img/back_button_black.png' onClick={closeClick} />
                    <Box
                        sx={{
                            margin: '16px 0 0 10px',
                            fontSize: '22px',
                            fontWeight: 'bold'
                        }}>
                        쿠폰 반환 신청
                    </Box>
                </Box>
                <Divider />
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        height: 'fit-content',
                    }}>
                    <Box
                        sx={{
                            width: '80%',
                            marginTop: '20px',
                        }}>
                        {/* <Box
                            sx={{
                                fontWeight: 'bold'
                            }}>
                            반환 정보
                        </Box> */}
                        <Box
                            sx={{
                                fontSize: '14px',
                                marginTop: '10px',
                            }}>
                            <Box display='inline-block' fontWeight='bold'>미출석한 최근 1개월 이내 쿠폰</Box>만 반환 가능합니다.
                            <Box>(1일 1쿠폰 인정)</Box>
                            <Box sx={{ mt: 1 }}>반환인정된 쿠폰은 보너스쿠폰으로 들어가게 됩니다.</Box>
                            <Box>보너스쿠폰 기간은 반환인정된 날부터 시작하여 쿠폰 한 장 당 3일로 계산하여 설정됩니다.</Box>
                            <Box sx={{ fontWeight: 'bold', mt: 1 }}>예시</Box>
                            <Box>12월 1일에 쿠폰 8장을 반환신청했고, 12월 7일에 쿠폰 6장만 반환 승인이 난 경우.</Box>
                            <Box>12월 7일부터 12월 25일까지 총 18일의 기간을 가진 보너스쿠폰 6장을 받을 수 있습니다.</Box>
                            <Box sx={{ mt: 1 }}>반환을 원하는 쿠폰을 선택하세요.</Box>
                        </Box>
                    </Box>
                    <DataGrid
                        sx={{
                            width: '90%',
                            marginTop: '15px'
                        }}
                        rows={plans}
                        columns={columns}
                        pageSize={5}
                        autoHeight={true}
                        checkboxSelection={true}
                        density='compact'
                        onSelectionModelChange={(newSeq) => {
                            setSeq(newSeq);
                        }}
                        selectionModel={seq}
                        // onRowModesModelChange={(newRow) => {
                        //     setRows(newRow);
                        // }}
                        // rowModesModel={rows}
                        onCellClick={console.log(seq)}
                    />
                    <Box
                        sx={{
                            width: '80%',
                            marginTop: '20px',
                            fontWeight: 'bold'
                        }}>
                        <Box
                            sx={{
                                // marginTop: '12px'
                            }}>
                            반환 사유
                        </Box>

                        <FormControl
                            sx={{
                                width: '100%',
                                marginTop: '12px'
                            }}>
                            <ThemeProvider theme={selectTheme}>
                                <InputLabel>사유 선택</InputLabel>
                            </ThemeProvider>
                            <Select
                                value={reason}
                                onChange={onChangeReason}
                                size='small'
                                label='사유 선택'
                            // open={coupon === '기타'?false:true}
                            >
                                <MenuItem value='코로나'>
                                    코로나 확진(본인만 해당)
                                </MenuItem>
                                <MenuItem value='천재지변'>
                                    천재지변(화재, 침수 등)
                                </MenuItem>
                                <MenuItem value='사고및질병'>
                                    사고 및 질병
                                </MenuItem>
                                <MenuItem value='부고'>
                                    부고(부모, 형제, 자매만 가능)
                                </MenuItem>
                                <MenuItem value='기타'>
                                    기타
                                </MenuItem>
                            </Select>

                        </FormControl>

                        {reason === '기타' ?
                            <TextField
                                value={reason_etc}
                                onChange={onChangeEtc}
                                type='text'
                                size='small'
                                placeholder='기타 사유를 적어주세요.'
                                sx={{ width: '100%', marginTop: '12px' }} />
                            : null}
                        <Box
                            sx={{
                                fontSize: '13px',
                                marginTop: '5px'
                            }}>
                            상기 사유에 대한 증명이 가능한 경우에만 신청 가능합니다.
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            // border: '1px solid black',
                            marginTop: '20px',
                            width: '80%',

                        }}>
                        <Box
                            sx={{
                                fontWeight: 'bold'
                            }}>
                            증명서류 첨부
                        </Box>
                        <label
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginTop: '12px'
                            }}>
                            <Input accept='image/jpeg' type='file' onChange={changeImg} />
                            <Button variant='contained' component='span'>
                                증명서 첨부
                            </Button>
                            {file === null && (
                                <Box component='span' sx={{ marginLeft: '10px', fontSize: '14px' }}>이미지를 선택하세요</Box>
                            )}
                            {file != null && (
                                <Box component='span' sx={{ marginLeft: '10px', fontSize: '14px' }}>{file.name}</Box>
                            )}
                        </label>
                        {/* <Box>{file}</Box> */}
                    </Box>
                    <Box sx={{ width: '100%', height: '100px' }}></Box>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        position: 'fixed',
                        bottom: '0',
                        background: 'white'
                    }}>
                    <Button variant='contained'
                        sx={{
                            width: '100%',
                            marginBottom: '20px',
                            marginTop: '10px',
                            borderRadius: '0',
                            background: '#0092a2',
                            '&:hover': {
                                background: '#0092a2',
                            }
                        }}
                        onClick={() => onSubmit()}
                    >
                        반환 신청
                    </Button>
                </Box>
            </Dialog>

            <ListItem
                sx={{ textAlign: "center" }}
                onClick={openClick}
            >
                <ListItemAvatar>
                    <ReturnIcon width='24px' height='24px' />
                </ListItemAvatar>
                <ListItemText sx={{ textAlign: "left" }}>
                    쿠폰 반환 신청
                </ListItemText>
                <ListItemAvatar>
                    <ArrowRightIcon />
                </ListItemAvatar>
            </ListItem>
        </Box>
    )
}

export default Return;